import { Directive, Input, ElementRef, ViewContainerRef, TemplateRef } from '@angular/core';
import { ControlContainer, FormGroupDirective } from '@angular/forms';

@Directive({
  standalone: false,
  selector: '[ngMessages]'
})
export class ControlMessagesDirective {
  constructor(
    private viewContainer: ViewContainerRef,
    private templateRef: TemplateRef<any>,
    private controlContainer: ControlContainer
  ) {
    //
  }

  @Input() set ngMessages(control: string) {
    this.form.controls[control].valueChanges.subscribe(() => {

    });
  }

  get form() {
    return this.controlContainer.formDirective
      ? (this.controlContainer.formDirective as FormGroupDirective).form
      : null;
  }
}
